const RULE_CATEGORY = require("./rule-category");
const OBSOLETE_TAGS = require("./obsolete-tags");
const VOID_ELEMENTS = require("./void-elements");

module.exports = {
  RULE_CATEGORY,
  OBSOLETE_TAGS,
  VOID_ELEMENTS,
};
